import {LTServices} from "../../lt-ng/lt-services";
import {L} from "../../lt-ng/landcare-toolkit";
import Item = L.tree.Item;
import filterNodes = L.tree.filterNodes;
import {_F} from "../../utility/func";
import termPrefixSearch = _F.termPrefixSearch;
import {CustomLayers} from "../../services/custom-layer-service";
import ICustomLayerService = CustomLayers.ICustomLayerService;
import groupBy = _F.groupBy;
import flatMap = _F.flatMap;
import groupByMany = _F.groupByMany;
import someNodes = L.tree.someNodes;
import getVisibleScienceLayers = L.tree.getVisibleScienceLayers;
import getUserSelectableLayers = L.tree.getUserSelectableLayers;
import {GeoAppEvents} from "../events/geoapp_events";
import {TourEvents} from "../../services/ITourService";
import IMapService = LTServices.IMapService;
import {checkChildren, checkParents, uncheckItem} from "./layer-selector-util";
import {optimizedResize} from "../../utility/optimised_resize";
import {ILocalDataLayers} from "../../services/local-data/service/LocalDataLayers";
import {_t} from "../../utility/i18n";
import {IToastResult, IToastService, TOAST_DURATION_LONG} from "../../services/ToastService";


type LayerConfigTab = 'topic' | 'category'|'source';

type LayerSettingsPanel = 'layerSelector' | 'customLayerSettings' | 'customLayer' | 'localData';

export interface ILayerSelectorScope extends ng.IScope {
	showAddLocalData: () => void;
	selectANode: (item: L.tree.Item) => void;
	handlePanelLabelClick: ($event: ng.IAngularEvent, node: L.tree.Item, context: string) => boolean;
	handleLabelClick: ($event: ng.IAngularEvent, node: Item) => boolean;
	isFirstChild: (node: L.tree.Item) => boolean;
	isLastChild: (node: L.tree.Item) => boolean;

	toggleAllChildren(item: L.tree.Item, context: string);
	expandButtonCls: (tab: string, item: L.tree.Item) => { "icon-minus": boolean; "icon-plus": boolean };
	numberOfLayers: (item: (L.tree.Item | L.tree.Item[])) => number;
	numberOfSelectedLayers: (item?: Item|Item[]) => number;
	layerSelectorTreeOptions: any;
	plusOrMinusClassOuter: (item: L.tree.Item) => string;
	toggleNode: (item: L.tree.Item) => void;
	plusOrMinusClass: (item: L.tree.Item) => { icon: boolean; "icon-plus": boolean; "icon-minus": boolean };
	treeDataError: boolean;
	moveUp(node: L.tree.Item);
	moveDown(node: L.tree.Item);
	removeNode(node: L.tree.Item);
	expandedNodes: Item[];
	tabClass(tab: LayerConfigTab) : string|object;
	activeTab: LayerConfigTab;
	showTab(tab: LayerConfigTab);

	expandedTopic: number|string;
	expandedCategory: number|string;
	expandedSource: number|string;

	toggleGroup(tab: string, idx: number|string, $event?: Event);
	expandOrCollapseGroup(tab: string, idx: number|string, expandOrCollapse: boolean);

	dataForTheTree: Item[];
	nodeFilter(item: Item): boolean;
	search: { text: string };
	anyLayersSelected() : boolean;
	nodeLabelClass(item: Item) : string|object;
	showSelected(item: Item, fromSource?: boolean);
	showAddLayer();
	layerTypes: { name: string, value: L.util.LayerType }[];
	layerSettings(item: Item);
	panel: LayerSettingsPanel;
	settingsItem: Item;
	showLayerSelector();
	title: string;
	clickBack();
	backStack: Array<() => void>;

	layerType(item: Item) : string;

	layersGroupedBySource: L.tree.Item[];
	startTour();
}

export class LayerSelectorCtrl {
	public static $inject = [
		'$scope',
		'landcareMapService',
		'customLayerService',
		'localDataLayers',
		'$timeout',
		'toastService',
		'$q'
	];

	constructor($scope: ILayerSelectorScope,
				mapService: IMapService,
				customLayerService: ICustomLayerService,
				localDataLayers: ILocalDataLayers,
				$timeout: ng.ITimeoutService,
				toastService: IToastService,
				$q: ng.IQService) {
		$scope.panel = 'layerSelector';

		$scope.backStack = [];

		$scope.expandedTopic = -1;
		$scope.expandedSource = -1;
		$scope.expandedCategory = -1;

		$scope.startTour = () => $scope.$emit(TourEvents.start);

		$scope.toggleGroup = (tab: string, idx: number|string, $event: Event = null) => {
			$scope[tab] = $scope[tab] == idx ? -1 : idx;
			if ($event) {
				$event.preventDefault();
				$event.stopPropagation();
			}
			return false;
		};

		$scope.expandOrCollapseGroup = (tab: string, idx: number|string, expandOrCollapse: boolean) => {
			$scope[tab] = expandOrCollapse ? idx : -1;
		}

		$scope.$on(GeoAppEvents.resetMapAndLayers, () => {
			$scope.expandedTopic = -1;
			$scope.activeTab = 'topic';
		});

		const CREATE_YOUR_MAP = _t('LAYER_SELECTOR.CONFIGURE_YOUR_MAP', 'Configure your map');
		const ADD_CUSTOM_LAYER = _t('LAYER_SELECTOR.ADD_WEB_DATA', 'Add web data');
		const ADD_LOCAL_DATA = _t('LAYER_SELECTOR.ADD_LOCAL_DATA', 'Add local data');

		$scope.clickBack = () => {
			if ($scope.backStack.length) {
				($scope.backStack.pop())();
			}
		};

		$scope.title = CREATE_YOUR_MAP;

		$scope.showLayerSelector = () => {
			$scope.panel = 'layerSelector';
			$scope.title = CREATE_YOUR_MAP;
			// $scope.clickBack = null;
			$scope.settingsItem = null;
		};

		optimizedResize.add(() => {
			if ($scope.activeTab == 'source' && window.innerWidth <= 767) {
				$scope.activeTab = 'topic';
			}
		});

		$scope.layerTypes = [
			{
				name: 'Context',
				value: 'CONTEXT'
			},
			{
				name: 'Science/Content',
				value: 'SCIENCE'
			},
			{
				name: 'Basemap',
				value: 'BASE'
			}
		];

		$scope.layerType = (item: Item) => {
			let types = $scope.layerTypes
				.filter((lt) => lt.value == item.layerType).map((lt) => lt.name);
			return types.length ? types[0] : '';
		};

		$scope.showAddLayer = () => {
			$scope.title = ADD_CUSTOM_LAYER;
			// $scope.clickBack = $scope.showLayerSelector;
			$scope.backStack.push($scope.showLayerSelector);
			$scope.panel = 'customLayer';
		};

		$scope.showAddLocalData = () => {
			$scope.title = ADD_LOCAL_DATA;
			$scope.backStack.push($scope.showLayerSelector);
			$scope.panel = 'localData';
		}

		$scope.search = {
			text : ''
		};

		$scope.activeTab = 'topic';

		$scope.layersGroupedBySource = [];

		const customSrcId = -1;
		const otherSrcId = -2;


		function getOtherSource() : L.util.Source[] {
			return ($scope.layersGroupedBySource || [])
				.filter((s) => s && s.sourceService && s.sourceService.id == otherSrcId)
				.map((s) => s.sourceService)
		}

		function getCustomSource() : L.util.Source[] {
			return ($scope.layersGroupedBySource || [])
				.filter((s) => s && s.sourceService && s.sourceService.id == customSrcId)
				.map((s) => s.sourceService)
		}

		function updateTreeData(treeData: any[]) {
			if (!treeData) {
				$scope.treeDataError = true;
				return;
			}

			$scope.dataForTheTree = getUserSelectableLayers(treeData);

			let firstLevelLayers = flatMap($scope.dataForTheTree, (g) => g.children);

			const customLayerGroup = mapService.getCustomLayerGroup();

			let nodesAsList = filterNodes(
					firstLevelLayers,
					(n) => {
						let isNotATopLevelGroup = n && n.parentId !== -1;
						if (isNotATopLevelGroup) {
							let noSource = !n.sources || !n.sources.length;
							let parentHasSource = (n && n.parent && n.parent.sources || []).length;
							return !(noSource && parentHasSource);
						}

						return false;
					})
				.filter(n => {
					if (n.isCustom) {
						// only include the top level layers in this tab
						return n.parent === customLayerGroup;
					}

					return true;
				});

			let sources = groupBy(flatMap(nodesAsList, (n) => n.sources || []), (s) => `${s.id}`);


			let customSource = {
				id: customSrcId,
				name: '3rd Party Layers'
			};

			let unspecified = {
				id: otherSrcId,
				name: 'Unspecified/Other'
			};

			sources[`${customSrcId}`] = [customSource];
			sources[`${otherSrcId}`] = [unspecified];

			let groupedBySource = groupByMany(nodesAsList, (t) => {
				if (!t.isCustom && (!t.sources || !t.sources.length)) {
					return [`${otherSrcId}`];
				}

				if (t.isCustom) {
					return [`${customSrcId}`];
				}

				return t.sources.map((s) => `${s.id}`);
			});

			let index = 10000;
			$scope.layersGroupedBySource = Object.keys(sources)
				.map((sid) => {
					let src : L.util.Source = sources[sid][0];
					let children : L.tree.Item[] = groupedBySource[sid];
					if (!children) {
						return null;
					}
					return {
						name: src.name,
						children,
						layerSelectorChildren: children,
						extraState: {
							metaLayerSelector: {
								checked: someNodes(children, (n) => n && n.extraState.metaLayerSelector.checked),
								expanded: false
							}
						},
						index: index++,
						rootItems: [],
						sourceService: {
							name: src.name,
							id: src.id,
							description: src.description
						}
					}
				}).filter((g) => g);

			$scope.layersGroupedBySource.sort((a, b) => a.name.localeCompare(b.name))
		}

		mapService.mapPromise.then(() => {
			updateTreeData(mapService.treeData);
			$scope.$emit('onTreeChange');
		});

		$scope.$on('updateTreeData', () => updateTreeData(mapService.treeData));

		$scope.tabClass = (tab) => {
			return {
				'active': tab == $scope.activeTab
			}
		};

		let currentRemoveNodeOp: ng.IDeferred<IToastResult>;

		$scope.removeNode = (node: Item) => {
			if (currentRemoveNodeOp) {
				currentRemoveNodeOp.resolve({ actionClicked: false });
			}

			currentRemoveNodeOp = $q.defer();

			node.extraState.metaLayerSelector.deleting = true;
			const toast = toastService.showToast(
				`Removing ${node.name}`,
				TOAST_DURATION_LONG,
				'toast-above-layer-selector',
				{
					label: 'Undo',
					onClick() {
						node.extraState.metaLayerSelector.deleting = false;
					}
				},
				"LayerSelector:removeNode"
			)

			$q.race([currentRemoveNodeOp.promise, toast])
				.then((result) => {
					if (!result.actionClicked) {
						if (node.isCustom) {
							customLayerService.removeLayer(node);
						}

						mapService.removeLayer(node);
					}
				});
		};

		function moveInArr<T>(item :T, arr :T[], delta: number) : T {
			let idx = arr.indexOf(item);
			let newIdx = Math.min(Math.max(idx+delta, 0), arr.length);
			let replacing = arr[newIdx];

			if (idx != newIdx) {
				arr[idx] = replacing;
				arr[newIdx] = item;
			}

			return replacing;
		}

		let move = (node: Item, delta: number) => {
			let parent = node.parent;

			moveInArr(node, parent.children, delta);
			moveInArr(node, parent.layerSelectorChildren, delta);
			$scope.layersGroupedBySource.filter((s) => {
				return s && s.layerSelectorChildren && s.layerSelectorChildren.some((c) => c == node);
			}).forEach((s) => moveInArr(node, s.layerSelectorChildren, delta));

			let layers = mapService.map.getLayers();

			customLayerService.save();
			layers.changed();
		};

		$scope.isFirstChild = (node: Item) => {
			return node.parent.children.indexOf(node) === 0;
		};

		$scope.isLastChild = (node: Item) => {
			return node.parent.children.indexOf(node) === node.parent.children.length - 1;
		};

		$scope.moveUp = (node) => {
			move(node, -1);
		};

		$scope.moveDown = (node) => {
			move(node, 1);
		};

		$scope.showTab = (tab) => {
			$scope.activeTab = tab;
		};

		let isExpanded = (i : Item) : boolean => i && i.extraState.metaLayerSelector.expanded;

		let updateSourceNodesCheckboxes = () => {
			$scope.layersGroupedBySource.forEach((s) => {
				s.extraState.metaLayerSelector.checked = someNodes(s.children, (c) => {
					return c && c.extraState && c.extraState.metaLayerSelector.checked;
				})
			})
		};

		$scope.expandedNodes = [];
		$scope.$on('onTreeChange', () => {
			$scope.expandedNodes = filterNodes(mapService.treeData || [], isExpanded);
			updateSourceNodesCheckboxes();
		});
		$scope.$emit('onTreeChange');

		let terms = [];
		$scope.numberOfLayers = (item: Item|Item[]) => {
			return item instanceof Array ? item.length : (item && item.children || []).length;
		};

		$scope.expandButtonCls = (tab: string, item: Item) => {
			let expanded = item.index == $scope[tab];
			return {
				'icon-minus': expanded,
				'icon-plus': !expanded
			}
		};

		$scope.numberOfSelectedLayers = (item : Item|Item[]) => {
			item = item || $scope.dataForTheTree;

			const list: Item[] = item instanceof Array ? item : (item && item.children || []);
			return list.filter(l => l.extraState.metaLayerSelector.checked).length;
		};

		$scope.anyLayersSelected = () => $scope.numberOfSelectedLayers() > 0;

		$scope.$watch('search.text', () => {
			terms = $scope.search.text.trim()
				.toLowerCase()
				.split(/\s+/)
				.filter((s) => s.length);
		});

		function getParents(node: Item) : Item[] {
			let parents = [];
			let p = node.parent;
			while(p) {
				parents.push(p);
				p = p.parent;
			}
			return parents;
		}

		$scope.nodeFilter = (item: Item) => {
			if (terms.length == 0) {
				return true;
			}

			return termPrefixSearch(terms, item.name.toLowerCase())
				|| (getParents(item).some((p) => termPrefixSearch(terms, p.name.toLowerCase())))
				|| (item.children && item.children.some((child) => $scope.nodeFilter(child)));
		};

		$scope.nodeLabelClass = (item) => {
			return {
				'layer-group' : !item.parent,
				'layer': item.layerType,
				'custom-layer': item.isCustom,
				'cls': item.classId,
				'attribute-name': item.description
			}
		};

		function checkSources(item: L.tree.Item) {
			let sources = item.sources;
			if (!sources || !sources.length) {
				sources = item.isCustom ? getCustomSource() : getOtherSource();
			}

			sources.forEach((s) => {
				$scope.layersGroupedBySource
					.filter((t) => t.sourceService && t.sourceService.id == s.id)
					.forEach((t) => {
							t.extraState.metaLayerSelector.checked =
								t.children.some((c) => {
									return c.extraState.metaLayerSelector.checked
								});
						}
					)
			});
		}

		$scope.showSelected = (item: Item, fromSource: boolean = false) => {
			$timeout(() => {

				const includedInLayerSelector = item.extraState.metaLayerSelector.checked;
				checkChildren(item, includedInLayerSelector);
				checkSources(item);
				checkParents(item);

				if (fromSource) {
					item.children.forEach(checkParents);
				}

				// The item has been removed from the map, but it is still visible.
				// It needs to be hidden
				if (item.checked && !includedInLayerSelector) {
					uncheckItem(item);
				}

				$scope.$root.$broadcast('layerIncluded:change', item);
				if (item.isCustom) {
					customLayerService.saveNode(item);
				}
			}, 0);
		};

		$scope.selectANode = (item: Item) => {
			$scope.showSelected(item, true);
		}

		$scope.toggleAllChildren = (item: Item, context: string) => {
			// used when clicking on a group's checkbox
			checkChildren(item, item.extraState.metaLayerSelector.checked);

			if (context == 'source-tab') {
				item.children.forEach(checkParents);
			}

			checkSources(item);
			item.children.forEach(checkSources);

			if (!item.extraState.metaLayerSelector.checked) {
				let checkedChildren = filterNodes(item.children, (n) => n && n.checked);
				if (checkedChildren.length) {
					checkedChildren.forEach(uncheckItem);
					$scope.$emit('geoApp:showLegendAndMetaData');
				}
			}
			$scope.$root.$broadcast('layerIncluded:change');
		};

		$scope.$on('showLayerSelector', () => {
			$scope.showLayerSelector();
			$scope.backStack = [];
		});

		$scope.layerSettings = (item: Item) => {
			$scope.settingsItem = item;
			$scope.panel = 'customLayerSettings';
			$scope.title = `${item.name} - settings`;
			$scope.backStack.push($scope.showLayerSelector);
		};

		$scope.toggleNode = (item: Item) => {
			item.extraState.metaLayerSelector.checked = !item.extraState.metaLayerSelector.checked;
			$scope.showSelected(item);
		};

		$scope.plusOrMinusClassOuter = (item: Item) : string => {
			let inc = item.extraState.metaLayerSelector.checked;
			return inc ? 'remove' : ''
		};

		$scope.plusOrMinusClass = (item: Item) => {
			let inc = item.extraState.metaLayerSelector.checked;
			return {
				'icon': true,
				'icon-plus': !inc,
				'icon-minus': inc,
			}
		};

		$scope.layerSelectorTreeOptions = {
			nodeChildren: "layerSelectorChildren",
			dirSelectable: true,
			injectClasses: {
				ul: "a1",
				li: "a2",
				liSelected: "a7",
				iExpanded: "a3",
				iCollapsed: "a4",
				iLeaf: "a5",
				label: "a6",
				labelSelected: "a8"
			}//,
			//templateUrl: "/angular-tree-control.html" // see app-page.ts for this configured properly!
		};
	}
}